export default __webpack_public_path__ + "static/media/simple1.57a10b1e.webp";